import '@/scss/pages/home/home.scss';

import {AnimateNumbers} from "@/js/pages/home/components/AnimateNumbers";
import {animation} from "@/js/pages/home/components/animation";
import {workflowAnimation} from "@/js/pages/home/components/workflowAnimation";
import {marqueeSlider} from "@/js/pages/home/components/marqueeSlider";
import {swipers} from "@/js/pages/home/components/swipers";

import {testimonialsSwiper} from "@/js/pages/home/components/testimonialsSwiper";
import {faq} from "@/js/global/components/faq";
import {colorMenuOnScroll} from "@/js/pages/home/components/colorMenuOnScroll";
import {coursesSwiper} from "@/js/pages/home/components/coursesSwiper";

window.addEventListener('load', () => {
    colorMenuOnScroll();
    coursesSwiper();
    testimonialsSwiper();
    faq();
});
